import { useEffect, useState } from "react"
import { FormDefinition, FormStage } from "../../types"
import { useCustomForm } from "../../hooks/useCustomForm"
import CustomForm from "../CustomForm"
import CustomFormSuccess from "../CustomFormSuccess"
import { ResponsiveColumns } from "@/ui/structure/Grid"

export interface CustomFormControllerProps<T> {
  definition: FormDefinition<T>
  gridColumns?: ResponsiveColumns
}

const CustomFormController = <T,>({
  definition,
  gridColumns,
}: CustomFormControllerProps<T>) => {
  const [formStage, setFormStage] = useState<FormStage>("form")
  const { handleSubmit, formState, submitState, registerField } = useCustomForm(
    {
      definition,
      onError: () => {
        setFormStage("error")
      },
      onSuccess: () => {
        setFormStage("success")
      },
    }
  )

  useEffect(() => {
    if (formStage === "success") {
      setTimeout(() => {
        setFormStage("form")
      }, 60 * 1000)
    }
  }, [formStage])

  if (formState.isValid) {
    console.log("contact form is valid")
  } else {
    console.log("contact form is invalid", formState.errors)
  }

  return (
    <>
      {(formStage === "form" || formStage === "error") && (
        <CustomForm
          definition={definition}
          formState={formState}
          registerField={registerField}
          onSubmit={handleSubmit}
          loading={submitState.loading}
          gridColumns={gridColumns}
        />
      )}
      {formStage === "success" && (
        <CustomFormSuccess contents={definition.messages.success} />
      )}
    </>
  )
}

export default CustomFormController
